import { css } from '@emotion/core';
import { shadow, tokens } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors,
  shadows = tokens.shadows;
var _ref = {
  name: "1szeoly",
  styles: "display:flex;flex-direction:row;align-items:flex-start;padding:12px 0px;"
};
var _ref2 = {
  name: "1a0yn55",
  styles: "width:300px;height:176px;"
};
var _ref3 = {
  name: "1p688ai",
  styles: "align-self:stretch;flex-grow:1;display:flex;flex-direction:column;justify-content:space-between;align-items:flex-start;padding:28px 16px 0px;"
};
var _ref4 = {
  name: "13brihr",
  styles: "text-align:left;"
};
var _ref5 = {
  name: "ku1jyq",
  styles: "text-align:left;flex-grow:1;"
};
var _ref6 = {
  name: "16k6d1l",
  styles: "padding:14px 16px;&:before{position:absolute;top:0;right:0;left:0;bottom:0;z-index:2;content:'';}"
};
var _ref7 = {
  name: "8atqhb",
  styles: "width:100%;"
};
export default (layout => {
  var isHorizontal = layout === 'horizontal';
  var nearbySales = /*#__PURE__*/css("display:flex;flex-direction:column;align-items:center;border:1px solid ", colors.neutral.trim.default, ";border-radius:3px;position:relative;&:hover{box-shadow:", shadow(shadows.elevation4), ";cursor:pointer;}", isHorizontal && _ref);
  var image = /*#__PURE__*/css("height:207px;width:100%;object-fit:cover;", isHorizontal && _ref2);
  var body = /*#__PURE__*/css("display:flex;flex-direction:column;align-self:stretch;", isHorizontal && _ref3);
  var heading = /*#__PURE__*/css(designTokenFonts.subheading, " margin:0 16px 12px;text-align:center;", isHorizontal && _ref4);
  var text = /*#__PURE__*/css(designTokenFonts.body, " text-align:center;margin:0 16px 18px;", isHorizontal && _ref5, " strong{", designTokenFonts.bodyBold, "}");
  var button = _ref6;
  var buttonText = /*#__PURE__*/css(designTokenFonts.bodyBold, " color:", colors.interactive.base.default, ";");
  var buttonIcon = /*#__PURE__*/css("color:", colors.interactive.base.default, ";");
  var buttonColours = {
    hoverBackground: 'inherit',
    hoverText: colors.interactive.base.default
  };
  var separator = _ref7;
  return {
    nearbySales,
    image,
    body,
    heading,
    text,
    button,
    buttonText,
    buttonIcon,
    buttonColours,
    separator
  };
});